/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
    video_modal: false,
    audio_modal: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'VIDEO_MODAL':
            return { ...state, ...action.data };
        case 'AUDIO_MODAL':
            return { ...state, ...action.data };

        default:
            return state;
    }
}
